import React, { useState, useEffect } from 'react';
import registryDesktop from '../Images/registryfordtfinal.mp4';
import registryMobile from '../Images/mobileregfix.mp4';
import '../styles/Registry.css';

function Registry() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    setIsMobile(mediaQuery.matches);

    const handler = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return (
    <div className="registry-video-container">
      <video
        src={isMobile ? registryMobile : registryDesktop}
        autoPlay
        muted
        loop
        playsInline
      />

      <button
        className="registry-video-button registry-button-one"
        onClick={() => window.open('https://www.crateandbarrel.com/gift-registry/emily-gillespie-and-corey-hutson/r7364104')}
      />

      <button
        className="registry-video-button registry-button-two"
        onClick={() => window.open('https://www.amazon.com/wedding/registry/1HR7V6DAPH7A7?ref=wr_search_page_result_1')}
      />

      <button
        className="registry-video-button registry-button-three"
        onClick={() => window.open('https://www.honeyfund.com/site/hutson-gillespie-06-06-2026')}
      />
    </div>
  );
}

export default Registry;
